import React, { useMemo } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack } from '@mui/material';

import { MappedAuditLog } from '~/services/AuditService';

import { AuditLog } from './AuditLog';
import { SurchargeDateBlockContent } from './SurchargeDateBlockContent';

type Props = {
  surchargeDateBlocks: Array<MappedAuditLog>;
};

type SurchargeDateBlock = {
  start_date?: string;
  end_date?: string;
  prices?: Record<string, number>;
  [key: string]: unknown;
};

export default function SurchargeDateBlockHistory({ surchargeDateBlocks }: Props) {
  const firstLog = surchargeDateBlocks[0];

  const summaryLog = useMemo((): SurchargeDateBlock => {
    if (firstLog.action === 'Create') return firstLog.diff?.added as SurchargeDateBlock;
    return firstLog.meta;
  }, [firstLog.action, firstLog.diff?.added, firstLog.meta]);

  return (
    <Accordion disableGutters sx={{ paddingLeft: '2em' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <SurchargeDateBlockContent surchargeDateBlock={summaryLog} />
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={1}>
          {surchargeDateBlocks.map((block) => {
            switch (block.action) {
              case 'Delete':
                return <AuditLog key={block.logId} auditLog={block} />;
              case 'Create':
                return (
                  <AuditLog key={block.logId} auditLog={block}>
                    <SurchargeDateBlockContent surchargeDateBlock={block.diff?.added as SurchargeDateBlock} />
                  </AuditLog>
                );
              case 'Update':
                return (
                  <AuditLog key={block.logId} auditLog={block}>
                    <SurchargeDateBlockContent surchargeDateBlock={block.meta as SurchargeDateBlock} />
                  </AuditLog>
                );
              default:
                return <div>Unknown action: {block.action}</div>;
            }
          })}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
